import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GameControlService {
  private gameFinishedSubject = new BehaviorSubject<boolean>(false);
  private activeGameId: string | null = null;
  

  // Observable that components can subscribe to
  gameFinished$ = this.gameFinishedSubject.asObservable();

  setActiveGame(gameId: string) {
    this.activeGameId = gameId;
  }

  getActiveGame(): string | null {
    return this.activeGameId;
  }

  resetGameState(){
    this.gameFinishedSubject.next(false);
    this.activeGameId = null;
  }

  triggerGameFinished() {
    this.gameFinishedSubject.next(true);
  }

  /**
   * Force cleanup of any active game
   */
  forceCleanup(): void {
    this.resetGameState();
  }
}
